import {defineStore} from 'pinia';
import {ref} from 'vue';
import {get,type WebsiteConfig,type MenuItem,type Category} from '../api';
export const useSite=defineStore('site',()=>{
  const config=ref<WebsiteConfig|null>(null),menus=ref<MenuItem[]>([]),categories=ref<Category[]>([]),error=ref(false),ready=ref(false);
  let pending:Promise<void>|null=null;
  const contentRevision=ref(0);
  let version='',checking=false;
  // 仅轮询轻量版本号；后台提交后再重新读取内容，避免持续下载大响应。
  async function checkUpdates(){
    if(checking)return;checking=true;
    try{
      const current=await get<{version:string}>('/revision');
      if(version&&version!==current.version){await refresh();contentRevision.value++;}
      version=current.version;
    }catch{}finally{checking=false;}
  }
  async function refresh(){
    if(pending)return pending;
    pending=(async()=>{
      try{
        const [settings,navigation,series]=await Promise.all([get<WebsiteConfig>('/config'),get<MenuItem[]>('/menus'),get<{items:Category[]}>('/categories')]);
        config.value=settings;menus.value=navigation;categories.value=series.items;error.value=false;ready.value=true;
      }catch(e){error.value=true;throw e;}finally{pending=null;}
    })();
    return pending;
  }
  const text=(key:string)=>config.value?.ui_text?.[key]||'';
  return{config,menus,categories,error,ready,refresh,text,contentRevision,checkUpdates};
});
